/**
 * 讲稿 markdown 渲染.
 *
 * 讲稿由离线流程生成、随资源一起入库, 展示时是 `x-html` 直接插进 DOM,
 * 因此必须过一遍 DOMPurify: 内容虽然来自我方资源库, 但 BOSS 后台允许人工编辑,
 * 不能假设它永远不含 script / onerror 这类注入。
 *
 * 渲染结果按源文本缓存: Alpine getter 每次重渲染都会调用, 不缓存会反复解析几十 KB。
 */

import DOMPurify from 'dompurify'
import { marked } from 'marked'

let cachedSource = ''
let cachedHtml = ''

/** 把讲稿 markdown 渲染成可安全插入的 HTML; 空文本返回空串 */
export function renderMarkdown(source: string): string {
  if (source === cachedSource) return cachedHtml
  cachedSource = source
  cachedHtml = source ? DOMPurify.sanitize(marked.parse(source, { async: false }) as string) : ''
  return cachedHtml
}
